import React from 'react';
import SettingsTable from 'sg/Tables/SettingsTable/SettingsTable.react';
import DownloadCSV from 'sg/Tables/SettingsTable/DownloadCSV.react';
import {Column} from 'sg/Tables/MandarkTable/MandarkTable.react';
import {sortDirections} from 'sg/Tables/tableConstants';
import ClassroomStatusFilters from '../Filters/ClassroomStatusFilters.react';
import EmptyUsageReport from './EmptyUsageReport.react';
import usageReportsStore from '../UsageReports.store';
import {
  getCountOfSchoolClassroomsContent,
  getCountOfSchoolTeachersContent,
  getCountOfSchoolStudentsContent,
  getCountOfSchoolAssignmentsContent,
  getStudentAttemptsContent,
  getPerformanceBarContent,
  getCSVHeaders
} from './utils';

export default class SubjectsReport extends React.Component {
  render() {
    return (
      <SettingsTable
        title='Usage'
        topFilters={<ClassroomStatusFilters />}
        defaultSortDirection={sortDirections.DESCENDING}
        query={usageReportsStore.getSubjectsQuery()}
        searchFilters={usageReportsStore.getSubjectSearchFilters}
        optionsMenu={
          <DownloadCSV
            csvQuery={usageReportsStore.getSubjectsCSVQuery}
            tableStoreName='SubjectUsageReportTableStore'
            fileName='subjects-usage-report'
            getCSVHeaders={getCSVHeaders('subjects')}
          />
        }
        storeName='SubjectUsageReportTableStore'
        emptyTableElement={
          <EmptyUsageReport
            headerText="You don't have any subjects!"
            bodyText="Subjects taught by teachers you've invited or approved will appear here."
          />
        }
      >
        <Column
          heading='Subject'
          sortBy='name'
          alwaysVisible
          content={(subject) => subject.getName()}
        />
        <Column
          heading='Classes'
          sortBy='meta.count_of_school_classrooms'
          defaultVisible
          className='sg-table__td--align-right'
          content={(subject) => getCountOfSchoolClassroomsContent(subject)}
        />
        <Column
          heading='Teachers'
          sortBy='meta.count_of_school_teachers'
          defaultVisible
          className='sg-table__td--align-right'
          content={(subject) => getCountOfSchoolTeachersContent(subject)}
        />
        <Column
          heading='Students'
          sortBy='meta.count_of_school_students'
          defaultVisible
          className='sg-table__td--align-right'
          content={(subject) => getCountOfSchoolStudentsContent(subject)}
        />
        <Column
          defaultSortParam
          heading='Student Attempts'
          sortBy='meta.count_of_school_guesses'
          defaultVisible
          className='sg-table__td--align-right'
          content={(subject) => getStudentAttemptsContent(subject)}
        />
        <Column
          heading='Assignments'
          sortBy='meta.count_of_school_assignments'
          className='sg-table__td--align-right'
          content={(subject) => getCountOfSchoolAssignmentsContent(subject)}
        />
        <Column heading='Performance' content={(subject) => getPerformanceBarContent(subject)} />
      </SettingsTable>
    );
  }
}
